import React, {FC, memo, MutableRefObject, ReactNode, useEffect, useState} from 'react'
import 'leaflet/dist/leaflet.css'
import {Popup} from 'leaflet'
import {MapContainer,} from 'react-leaflet'
import LeafletTitleLayer from '@ui/leafletCustom/titleLayer/LeafletTitleLayer'
import {getInitialLayer} from '@ui/leafletCustom/titleLayer/helpers/getInitialLayer'

import MapSearch from '../mapSearch/MapSearch'
import {useThemeContext} from '@view/theme/context/hooks/useThemeContext'
import {MapFeatures} from '@ui/leafletCustom/types'
import {ISxMap} from '@ui/leafletCustom/leafletContainer/types'
import {MediaStyle} from '@baseTypes/base'
import {LeafletFullscreenControl} from '@ui/leafletCustom/leafletFullscreenControl/LeafletFullscreenControl'
import './styles.css'
import MapFeaturesContextProvider from '@ui/leafletCustom/context/mapContext/MapZoomLevelContextProvider'
import LeafletContainerView from '@ui/leafletCustom/leafletContainer/LeafletContainerView'
import {LatLngCor} from '@ui/leafletCustom/types/latLng'
import {useMedia} from '@hooks/ui/useMedia'

const MOBILE_POPUP_PADDING_TOP_LEFT: [number, number] = [64, 56]

type MapFeaturesRefCallback = (mapFeatures: MapFeatures) => void

interface IProps {
    children: ReactNode,
    zoom?: number,
    center?: LatLngCor,
    hasFullScreen?: boolean,
    hasSearchbar?: boolean,
    doubleClickZoom?: boolean | 'center',
    mapFeaturesRef?: MutableRefObject<MapFeatures> | MapFeaturesRefCallback,
    zoomControl?: boolean,
    sx?: ISxMap,
    size?: {
        height?: MediaStyle<string | number>,
        width?: MediaStyle<string | number>,
    },

}


const LeafletContainer: FC<IProps> = memo(({
                                               children,
                                               center,
                                               zoom = 13,
                                               hasFullScreen = true,
                                               doubleClickZoom,
                                               mapFeaturesRef,
                                               zoomControl,
                                               hasSearchbar = true,
                                               size,
                                               sx = {},
                                           }) => {

    const {theme} = useThemeContext()
    const [titleLayerKey, setTitleLayerKey] = useState(() => getInitialLayer(theme))
    const {isDesktop} = useMedia()

    useEffect(() => {
        Popup.mergeOptions({
            autoPanPaddingTopLeft: isDesktop ? null : MOBILE_POPUP_PADDING_TOP_LEFT,
        })
    }, [isDesktop])

    return (
        <LeafletContainerView
            titleLayerKey={titleLayerKey}
            sx={sx}
            size={size}
        >
            <MapContainer
                zoom={zoom}
                zoomControl={zoomControl}
                scrollWheelZoom={true}
                center={center}
                doubleClickZoom={doubleClickZoom}
                ref={mapFeaturesRef}
            >
                {hasFullScreen && <LeafletFullscreenControl position={'bottomright'}/>}

                {hasSearchbar && <MapSearch/>}

                <LeafletTitleLayer
                    titleLayer={titleLayerKey}
                    setTitleLayer={setTitleLayerKey}
                />

                <MapFeaturesContextProvider>
                    {children}
                </MapFeaturesContextProvider>
            </MapContainer>
        </LeafletContainerView>
    );
});

export default LeafletContainer;